<template>
  <v-card>
    <v-card-item>
      <v-row>
        <v-col cols="10">
          <v-card-title>{{ machine.name }}</v-card-title>
        </v-col>
        <v-col cols="1">
          <v-icon
            v-if="isDatabaseAdmin"
            icon="mdi-pencil"
            @click="$emit('edit')" />
        </v-col>
        <v-col cols="1">
          <v-icon
            v-if="isDatabaseAdmin"
            icon="mdi-trash-can"
            @click="$emit('delete')" />
        </v-col>
      </v-row>
    </v-card-item>
    <v-card-text>
      <!-- <v-text-field
        variant="underlined"
        readonly
        v-model="machine.name"
        :label="$t(`entities.machine.fields.name`)" /> -->
      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.category_machine"
        :label="$t(`entities.machine.fields.category_machine`)" />

      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.type_machine"
        :label="$t(`entities.machine.fields.type_machine`)" />

      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.id_number_machine"
        :label="$t(`entities.machine.fields.id_number_machine`)" />

      <v-row>
        <v-col
          cols="6"
          class="mb-10">
          <QuillEditor
            :key="machine.id"
            readOnly
            v-model:content="machine.comment"
            theme="snow"
            content-type="html"
            :label="$t(`entities.machine.fields.comment`)"
            :height="300" />
        </v-col>
        <v-col cols="6">
          <CarouselWithUpload
            read-only
            ref="uploadRef"
            field="basic-data-machine"
            :node-id="machine.id"
            :upload-later="true"
            space-id="null" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-title>{{ t(`entities.machine.tabs.fixCost`) }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.acquisition_costs_machine"
            :label="$t(`entities.machine.fields.acquisition_costs_machine`)"
            :rules="[required, positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.installation_and_transportation_costs_machine"
            :label="
              $t(
                `entities.machine.fields.installation_and_transportation_costs_machine`
              )
            "
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.special_foundation_costs_machine"
            :label="
              $t(`entities.machine.fields.special_foundation_costs_machine`)
            "
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.other_costs_machine"
            :label="$t(`entities.machine.fields.other_costs_machine`)"
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.residual_value_machine"
            :label="$t(`entities.machine.fields.residual_value_machine`)"
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.useful_life_machine"
            :label="$t(`entities.machine.fields.useful_life_machine`)"
            :rules="[required, positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.required_space_including_auxiliary_areas_machine"
            :label="
              $t(
                `entities.machine.fields.required_space_including_auxiliary_areas_machine`
              )
            "
            :rules="[positive]" />
        </v-col>
        <v-col cols="6">
          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.replacement_costs_machine"
            :label="$t(`entities.machine.fields.replacement_costs_machine`)"
            :rules="[required, positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="
              machine.future_installation_and_transportation_costs_machine
            "
            :label="
              $t(
                `entities.machine.fields.future_installation_and_transportation_costs_machine`
              )
            "
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.future_special_foundation_costs_machine"
            :label="
              $t(
                `entities.machine.fields.future_special_foundation_costs_machine`
              )
            "
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.future_disposal_costs_machine"
            :label="$t(`entities.machine.fields.future_disposal_costs_machine`)"
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.future_other_costs_machine"
            :label="$t(`entities.machine.fields.future_other_costs_machine`)"
            :rules="[positive]" />

          <v-text-field
            variant="underlined"
            readonly
            v-model="machine.future_residual_value_machine"
            :label="$t(`entities.machine.fields.future_residual_value_machine`)"
            :rules="[positive]" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-title>{{ t(`entities.machine.tabs.variableCost`) }}</v-card-title>
    <v-card-text>
      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.maintenance_costs_year_machine"
        :label="$t(`entities.machine.fields.maintenance_costs_year_machine`)"
        :rules="[required, positive]" />

      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.connected_load_machine"
        :label="$t(`entities.machine.fields.connected_load_machine`)"
        :rules="[required, positive]" />

      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.power_consumption_machine"
        :label="$t(`entities.machine.fields.power_consumption_machine`)"
        :rules="[required, positive]" />

      <v-text-field
        variant="underlined"
        readonly
        v-model="machine.operating_material_costs_year_machine"
        :label="
          $t(`entities.machine.fields.operating_material_costs_year_machine`)
        "
        :rules="[required, positive]" />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import CarouselWithUpload from "@/components/Elements/CarouselWithUpload.vue";
import { ref, useTemplateRef } from "vue";
import { useTranslation } from "i18next-vue";
import { useCommonRules } from "@/validations/common";
import axios from "axios";
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();
const isDatabaseAdmin = authStore.isDatabaseAdmin;

const { t } = useTranslation();
const { required, positive } = useCommonRules(t);

const emit = defineEmits(["edit", "delete"]);

const props = defineProps({
  machine: {
    type: Object,
    required: false
  }
});
</script>

<style scoped>
.v-text-field {
  pointer-events: none;
  margin-bottom: 10px;
}
</style>
